import React from 'react'
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { toastMessages } from '../../constants/toastMessage';
import { setToastMessage } from '../../appState/slices/util/utilSlice';
import './toast.css'
import AddedItemModal from '../AddedItemModal/AddedItemModal';

const Toast = () => {
  const {
    type = "success",
    message = "Error",
    itemmodal,
    product,
    purity,
    quality,
    price,
    ringsize,
    diamondtype,
    color,
    show = true,
    timeout = 2400,
  } = useSelector((state) => state.util.toaster);

  const dispatch = useDispatch();

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        dispatch(
          setToastMessage({
            type: toastMessages.TYPE.ERROR,
            message: "",
            show: false,
          })
        );
      }, timeout);
    }
  }, [show, timeout]);

  if (show) {
    return (
      <div>
        {itemmodal ? 
      <div className="cart-modal-half">
      <div className="label t7 font-semibold">
        <AddedItemModal product = {product} color = {color} purity = {purity} quality = {quality} price = {price} ringsize = {ringsize} diamondtype = {diamondtype} />
      </div>
      
    </div>
    :
    <div className={`toaster ${type}`}>
      <div className="label t7 font-semibold">
        {message}
      </div>
      <div
      className={`close-icon  ${type}`}
      onClick={() => {
        dispatch(
          setToastMessage({
            type: toastMessages.TYPE.ERROR,
            message: "",
            show: false,
          })
        );
      }}
    >
      x
    </div>
      
    </div>
      }

      </div>
      
    );
  }

  // Return null if `show` is false (no toast to display)
  return null;
}

export default Toast;
